import facebook from "../../../assets/images/social/facebook.svg";
import x from "../../../assets/images/social/x.svg";
import whatsapp from "../../../assets/images/social/whatsapp.svg";
import telegram from "../../../assets/images/social/telegram.svg";
import linkedin from "../../../assets/images/social/linkedin.svg";

export const SOCIAL_MEDIA_PLATFORMS = [
  {
    id: "whatsapp",
    title: "Whatsapp",
    img: whatsapp,
    getShareUrl: url => {
      const msg = `Read article. \n Click here: ${url} `;
      return `https://api.whatsapp.com/send?text=${encodeURIComponent(
        msg
      )}`;
    },
  },
  {
    id: "x",
    title: "X",
    img: x,
    getShareUrl: url =>
      `http://twitter.com/share?text=${encodeURIComponent(
        url
      )}`,
  },
  {
    id: "facebook",
    title: "Facebook",
    img: facebook,
    getShareUrl: url =>
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        url
      )}`,
  },
  {
    id: "telegram",
    title: "Telegram",
    img: telegram,
    getShareUrl: url =>
      `https://telegram.me/share/url?url=${encodeURIComponent(
        url
      )}`,
  },
  {
    id: "linkedin",
    title: "LinkedIn",
    img: linkedin,
    getShareUrl: url =>
      `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
        url
      )}`,
  },
];

export const COPY_LINK = "Copy Link";

export const COPY_TO_CLIPBOARD_TITLE =
  "Article Link Copied";

export const SHARE_WIDGET_DATA = {
  TITLE: "t3",
  SOCIAL_PLATFORM: "t4",
  SHARE_LINK: "t5",
  COPY_LINK: "t6",
  PLATFORM: "t7",
};
